import moment from 'moment';

//  ================
/**
 * main function to format date used all over the app
 * @param string date in sql format
 * @returns string date in format: 2020-01-01, 00:00:00 with utc appended at the end if the sql date is in utc
 */

export const formatDate = (str?: string, displayHours = false): string => {
  if (!str) return '';
  // the format jan 01, 2007
  return moment(new Date(str)).format(displayHours ? 'MMM DD, YYYY, HH:mm:ss' : 'MMM DD, YYYY');
};

export class DateHelper {
  static GetIsoDateString = (d: Date): string => {
    return moment(d).format('YYYY-MM-DD');
  };

  static GetUTCIsoDateStartString = (d: Date): string => {
    return moment(d).startOf('day').toISOString();
  };

  static GetUTCIsoDateEndString = (d: Date): string => {
    return moment(d).endOf('day').toISOString();
  };

  static IsoStringToDateWithoutTimeZone = (s: string): Date => {
    return moment(s).utc().toDate();
  };

  static GetDatePartForIsoDatestring = (d: Date): string => {
    return moment(d).format('YYYY-MM-DD');
  };
}

export const FixTimeZoneOffset = (d: Date): Date => {
  if (!d) return new Date();
  const date = new Date(d);
  const userTimezoneOffset = date.getTimezoneOffset() * 60 * 1000;
  return new Date(date.getTime() - userTimezoneOffset);
};

export const formatUTCDate = (iso: string): string => {
  const date = new Date(iso); // Interprets as UTC
  if (isNaN(date.getTime())) throw new Error("Invalid date");

  const pad = (n: number) => n.toString().padStart(2, "0");

  const yyyy = date.getUTCFullYear();
  const mm = pad(date.getUTCMonth() + 1);
  const dd = pad(date.getUTCDate());
  const HH = pad(date.getUTCHours());
  const MM = pad(date.getUTCMinutes());

  return `${yyyy}-${mm}-${dd} ${HH}:${MM}`;
}
